.workbench-layout {
  --bg-primary: 255 255 255;
  --bg-primary-dark: 51 51 51;
  --fg-primary: 0 0 0;
  --fg-primary-dark: 255 255 255;

  --bg-color: var(--bg-primary);
  --fg-color: var(--fg-primary);

  :global(.dark) & {
    --bg-color: var(--bg-primary-dark);
    --fg-color: var(--fg-primary-dark);
  }

  grid-template:
    ' header ' auto
    ' main   ' auto
    ' right  ' 1fr
    / 1fr;

  @media (min-width: theme('screens.mlg')) {
    /* prettier-ignore */
    grid-template:
      ' header      header header ' auto
      ' left        main   right  ' 1fr
      / min-content 1fr    320px;

    /* Animates with TaskAndFavTabs' rail width on Chrome 111+ / Safari 17+ (intrinsic track interpolation); others snap. */
    transition: grid-template-columns 200ms ease-out;
  }
}
